module.exports = __webpack_public_path__ + "img/IMG_2523-2.fa116c9a.jpg";